import { apiClient } from "../api/apiClient";

import {
  ApiResponse,
  Category,
  CreateCategoryRequest
} from "../interfaces/Category";

// ======================================
// CATEGORY SERVICE
// ======================================

export const categoryService = {

// ======================================
// GET ALL
// ======================================


getAll: async (): Promise<Category[]> => {

  const response =
    await apiClient.get<
      ApiResponse<Category[]>
    >(
      "/Categories/GetAll"
    );

  const result =
    response.data;
    
      console.log( "Category Data List:",result.dataList);

  if (!result.isSuccess) {

    throw new Error(
      result.message
    );
  }

  // return result.data || [];
  return result.dataList || [];
},
getActiveAll: async (): Promise<Category[]> => {

  const response =
    await apiClient.get<ApiResponse<Category[]>>(
      "/Categories/GetActiveAll"
    );

  const result = response.data;

  if (!result.isSuccess) {
    throw new Error(result.message);
  }

  return result.dataList ?? [];
},
  // ======================================
  // GET BY ID
  // ======================================

getById: async (
  id: number
): Promise<Category> => {

  const response =
    await apiClient.get<
      ApiResponse<Category>
    >(
      `/Categories/${id}`
    );

  const result =
    response.data;

  if (!result.isSuccess) {

    throw new Error(
      result.message
    );
  }

  if (!result.data) {

    throw new Error(
      "Category not found"
    );
  }

  return result.data;
},

  // ======================================
  // CREATE
  // ======================================

  create: async (
    payload: CreateCategoryRequest
  ) => {

    const formData =
      new FormData();

    formData.append(
      "CategoryName",
      payload.categoryName
    );

    formData.append(
      "CategorySlug",
      payload.categorySlug
    );

    formData.append(
      "Description",
      payload.description || ""
    );

    formData.append(
      "DisplayOrder",
      payload.displayOrder.toString()
    );

    formData.append(
      "IsFeatured",
      payload.isFeatured.toString()
    );

    formData.append(
      "Status",
      payload.status || "active"
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    // IMAGE

    if (payload.categoryImage) {

      formData.append(
        "CategoryImage",
        payload.categoryImage
      );
    }

    if (payload.ogImage) {

      formData.append(
        "OgImage",
        payload.ogImage
      );
    }

    const response =
      await apiClient.post(
        "/Categories/Create",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // UPDATE
  // ======================================

  update: async (
    payload: CreateCategoryRequest & {
      categoryID: number;
    }
  ) => {

    const formData =
      new FormData();

    formData.append(
      "CategoryID",
      payload.categoryID.toString()
    );

    formData.append(
      "CategoryName",
      payload.categoryName
    );

    formData.append(
      "CategorySlug",
      payload.categorySlug
    );

    formData.append(
      "Description",
      payload.description || ""
    );

    formData.append(
      "DisplayOrder",
      payload.displayOrder.toString()
    );

    formData.append(
      "IsFeatured",
      payload.isFeatured.toString()
    );

    formData.append(
      "Status",
      payload.status || "active"
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    // IMAGE

    if (payload.categoryImage) {

      formData.append(
        "CategoryImage",
        payload.categoryImage
      );
    }

    if (payload.ogImage) {

      formData.append(
        "OgImage",
        payload.ogImage
      );
    }

    const response =
      await apiClient.put(
        "/Categories/Update",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // DELETE
  // ======================================

  delete: async (
    id: number
  ) => {

    const response =
      await apiClient.delete(
        `/Categories/${id}`
      );

    return response.data;
  }
};
